import { useNavigate } from 'react-router-dom';
import { Col, Row } from "reactstrap"

export const ReadyLink = () => {
    const navigate = useNavigate();

    return (
        <div className="whatsNextReadyLink" onClick={() => { navigate("/ContactUs/"); }}>
            <Row className="justifyEnd">
                <Col className="readyLinkHeading">
                    <p>If you're ready, sign up!</p>
                </Col>
            </Row>
            <Row className="justifyEnd">
                <Col className="readyLinkBody">
                    <p>
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.53578 12.0749L12.1758 6.43492L6.53578 0.794922L5.47292 1.85778L9.30435 5.68064L0.304353 5.68064V7.18064L9.30435 7.18064L5.47292 11.0121L6.53578 12.0749Z" fill="white" />
                        </svg>
                        <span>&nbsp;&nbsp;Full Fleet Assessment</span>
                    </p>
                </Col>
            </Row>
            <Row className="justifyEnd">
                <Col className="readyLinkImageCol">
                    <img className="readyLinkImage" src="/assets/images/vehicle_row_1_327x132.png" alt="Sign up for a full fleet assessment."/>
                </Col>
            </Row>
        </div>
    )
}
